import {Component, OnInit} from '@angular/core';

@Component({
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }
}
